import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import "react-step-progress-bar/styles.css";
import { Grid, Typography, LinearProgress } from '@material-ui/core';

import LearningContentCategoriesContext from '../../../context/learningContentContext/learningContentCategories-context';

import { removeLearningContentFromSession, setLearningContentSession, setLearningContentLevel } from '../../../utils/helpers/others/SessionHelper';
import useStyles from '../../../styles/components/learningcontent/stylesLearningContentCategoryHolder'

const LearningContentCategoryHolder = () => {
    const classes = useStyles()
    const history = useHistory();
    const { learningContentCategoriesContext } = useContext(LearningContentCategoriesContext);

    const selectLearningContentCategory = (traitGroupId, traitGroupName, levelText) => {
        const learningContent = {
            learningContentCategoryId: traitGroupId,
            learningContentCategoryName: traitGroupName,
            levelText: levelText > 0 ? levelText : 0,
            learningContentId: null
        };
        setLearningContentLevel(levelText > 0 ? levelText : 0)
        removeLearningContentFromSession();
        setLearningContentSession(JSON.stringify(learningContent));
        history.push("/LearningContents");
    }

    return (
        <>
            {
                learningContentCategoriesContext &&
                (learningContentCategoriesContext.learningContentCategories).map((learningContentCategory) => (
                    <Grid
                        key={learningContentCategory.traitGroupId}
                        container
                        alignItems="center"
                        justify="center"
                        classes={{ root: classes.rootContainer }}
                        onClick={() => selectLearningContentCategory(learningContentCategory.traitGroupId, learningContentCategory.traitGroupName, learningContentCategory.levelText > 0 ? learningContentCategory.levelText : 0)}
                    >
                        <Grid classes={{ root: classes.rootContainerImage }}>
                            <div>
                                <img src={learningContentCategory.logoPath} />
                            </div>
                        </Grid>
                        <Grid
                            classes={{ root: classes.rootContainerContent }}
                        >
                            <Grid>
                                <Typography className={classes.title}>{learningContentCategory.traitGroupName}</Typography>
                            </Grid>
                            <Grid container classes={{ root: classes.rootContainerDescription }}>
                                <Grid container item xs={6} justify="flex-start">
                                    <Typography className={classes.description}>Number of Learning Resources : {learningContentCategory.activeContentNum}</Typography>
                                </Grid>
                                <Grid container item xs={6} justify="flex-end">
                                    {
                                        learningContentCategory.percentage > 100 ?
                                            <Typography className={classes.description}>LEVEL : EXTRA MAX</Typography>
                                            :
                                            <Typography className={classes.description}>LEVEL : {learningContentCategory.levelText > 0 ? learningContentCategory.levelText : 0}</Typography>
                                    }

                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item sm={12} xs={12}>
                                    <LinearProgress
                                        variant="determinate"
                                        value={learningContentCategory.percentage > 100 ? 100 : learningContentCategory.percentage}
                                        classes={{ root: classes.rootProgressBar, bar: classes.barProgressBar }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ))
            }
        </>
    );
}

export default LearningContentCategoryHolder;